<template>
  <el-popover
    placement="left"
    width="300"
    :tabindex="10000"
    popperClass="JZPopper"
    v-model="showAttribute"
    trigger="manual">
    <div class="table-header-top">
      <span>字段设置</span>
      <time @click="showAttribute = false">&times;</time>
    </div>
    <draggable v-model="lockLists" draggable=".table-header-list-item">
      <template v-if="lockLists && lockLists.length">
        <li v-for="(item, index) in lockLists" :key="item.fieldName" class="table-header-list-item">
          <el-checkbox
            v-model="item.isShow"
            :disabled="item.isDisabled"
            style="margin-top: 6px"
          ></el-checkbox>
          <div class="table-header-labelContainer">{{ item.fieldName }}</div>
          <i
            :class="{ 'el-icon-unlock': !item.isRegular, 'el-icon-lock': item.isRegular }"
            style="font-size: 12px; margin-top: 10px; margin-left: 12px"
            @click="handleClickLock(item, index)"
          ></i>
          <i class="el-icon-s-unfold" style="font-size: 12px; margin-top: 10px; margin-left: 12px"></i>
        </li>
      </template>
      <template v-else>
        <li class="table-header-noFixedItem">锁定下列项目到此固定</li>
      </template>
    </draggable>
    <h3 class="table-header-unfixed">不固定</h3>
    <draggable v-model="attrLists" draggable=".table-header-list-item">
      <li v-for="(item, index) in attrLists" :key="item.fieldName" class="table-header-list-item">
        <el-checkbox
          v-model="item.isShow"
          :disabled="item.isDisabled"
          style="margin-top: 6px"
        ></el-checkbox>
        <div class="table-header-labelContainer">{{ item.fieldName }}</div>
        <i
          :class="{ 'el-icon-unlock': !item.isRegular, 'el-icon-lock': item.isRegular }"
          style="font-size: 12px; margin-top: 10px; margin-left: 12px"
          @click="handleClickLock(item, index)"
        ></i>
        <i class="el-icon-s-unfold" style="font-size: 12px; margin-top: 10px; margin-left: 12px"></i>
      </li>
    </draggable>
    <div class="table-header-text-right">
      <el-button type="default" size="mini" @click="handleResetCancel">重置</el-button>
      <el-button type="primary" size="mini" @click="handleSaveConfig">保存</el-button>
    </div>
    <el-button
      slot="reference"
      @click="handleSort"
      style="width: 32px; height: 32px; margin-left: 8px; padding: 8px">
      <img :src="require('@/assets/ic_setting.svg')" style="width: 16px; height: 16px; font-size: 16px" />
    </el-button>
  </el-popover>
</template>
<script>
import draggable from 'vuedraggable';
import { getFiledRuleLists, addFiledRule } from '@/api/contract';
export default {
  components: {
    draggable,
  },
  props: {
    // 自定义配置类型
    businessType: {
      type: String,
      default: '',
    },
    // 必选项，不可取消勾选
    disabledList: {
      type: Array,
      default: () => ([]),
    },
    // 最原始表头（不含操作）
    baseLists: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      showAttribute: false,
      attrLists: [],
      lockLists: [],
      attrPropLists: [],
      lockPropLists: [],
    };
  },
  mounted () {
    this.getRuleLists();
  },
  methods: {
    handleSort () {
      this.attrLists = this.attrPropLists;
      this.lockLists = this.lockPropLists;
      this.showAttribute = true;
    },
    handleResetCancel () {
      let columnList = this.baseLists;
      let attrLists = columnList.map((i, index) => ({
        fieldKey: i.key,
        fieldName: i.title || i.originTitle,
        businessType: this.businessType,
        isRegular: false,
        isShow: true,
        sort: index + 1,
      }));
      this.attrLists = attrLists.map(i => ({
        ...i,
        isDisabled: this.disabledList.includes(i.fieldKey),
      }));
      this.lockLists = [];
    },
    handleSaveConfig () {
      let lists = [...this.lockLists, ...this.attrLists].map((i, index) => ({
        ...i,
        sort: index + 1,
      }));
      addFiledRule(lists).then(() => {
        this.getRuleLists();
        this.showAttribute = false;
      });
    },
    // 这里需要处理table
    getColumnsLists (lists) {
      let originIdLists = lists.map(i => i.fieldKey);

      let newBaseLists = this.baseLists.map((item, index) => {
        const base = lists.find(row => row.fieldKey === item.dataIndex);
        item.sort = base?.sort ? Number(base.sort) : (index + 1);
        return item;
      });

      let baseIdLists = newBaseLists.map(i => i.dataIndex);

      let showIdLists = lists.filter(i => i.isShow).map(i => i.fieldKey);

      let fixedIdLists = lists.filter(i => i.isShow && i.isRegular).map(i => i.fieldKey);

      // 剔除 baseLists 中删掉的项
      showIdLists = baseIdLists.filter(i => showIdLists.includes(i));

      // 添加 baseLists 中新增的项
      const addIdLists = [];
      baseIdLists.map((i, index) => {
        if (!originIdLists.includes(i)) {
          addIdLists.push({
            name: i,
            index,
          });
        }
      });
      if (addIdLists.length) {
        addIdLists.map(i => {
          showIdLists.splice(i.index, 0, i.name);
        });
      }

      let currentLists = newBaseLists.filter(i => showIdLists.includes(i.dataIndex)).map(i => ({
        ...i,
        fixed: fixedIdLists.includes(i.dataIndex) ? 'left' : '',
      }));
      let tempLists = [];
      for (let i = 0; i < showIdLists.length; i++) {
        const info = currentLists.find(j => j.key === showIdLists[i]);
        tempLists.push(info);
      }

      // 按sort升序排列
      tempLists = tempLists.sort((a, b) => a.sort - b.sort);

      // AntDesign BUG: 处理fixed:left列，将这些列放在最前面，解决固定列未放在最前面，会遮挡未固定列的问题
      tempLists = this.moveToFront(tempLists, item => item.fixed === 'left');

      const columnList = [ ...tempLists ];

      this.$nextTick(() => {
        this.$emit('updateColumnList', columnList);
      });
    },
    moveToFront (arr, condition) {
      // 筛选出符合条件的元素
      const matched = arr.filter(condition);
      // 筛选出不符合条件的元素
      const others = arr.filter(item => !condition(item));
      // 合并数组，符合条件的元素在前
      return [...matched, ...others];
    },
    handleClickLock (item, index) {
      if (item.isRegular) {
        item.isRegular = false;
        this.lockLists.splice(index, 1);
        this.attrLists.push(item);
      } else {
        item.isRegular = true;
        this.attrLists.splice(index, 1);
        this.lockLists.push(item);
      }
    },
    getRuleLists () {
      getFiledRuleLists({
        businessType: this.businessType,
      }).then(({ body }) => {
        let currentLists = body || [];

        if (currentLists && currentLists.length) {
          this.attrLists = currentLists.filter(i => !i.isRegular);
          this.lockLists = currentLists.filter(i => i.isRegular);
          this.lockLists.map(item => {
            item.isDisabled = this.disabledList.includes(item.fieldKey);
            return item;
          });
          this.getColumnsLists(currentLists);
        } else {
          let columnList = [ ...this.baseLists ];

          // 这里需要根据 columnList 获取需要处理的数据的值
          let lockLists = columnList
            .filter(i => i.fixed && i.title !== '操作')
            .map((i, index) => ({
              fieldKey: i.key,
              fieldName: i.title || i.originTitle,
              businessType: this.businessType,
              isRegular: false,
              isShow: true,
              sort: index + 1,
            }));
          let attrLists = columnList
            .filter(i => !i.fixed && i.title !== '操作')
            .map((i, index) => ({
              fieldKey: i.key,
              fieldName: i.title || i.originTitle,
              businessType: this.businessType,
              isRegular: false,
              isShow: true,
              sort: lockLists.length + index + 1,
            }));

          this.attrLists = attrLists;
          this.lockLists = lockLists;
          this.$nextTick(() => {
            this.$emit('updateColumnList', columnList);
          });
        }

        // 这里需要拼接字段属性
        this.attrPropLists = this.attrLists.map(i => ({
          ...i,
          isDisabled: this.disabledList.includes(i.fieldKey),
        }));
        this.lockPropLists = this.lockLists;
      });
    },
  },
};
</script>
<style lang="scss">
.table-header-top {
  display: flex;
  padding: 6px 0;
  background: #ffffff;
  box-shadow: inset 0 -1px 0 0 #dfe2e8;
  margin-bottom: 10px;
  font-family: PingFang SC;
  font-size: 16px;
  color: #1f2733 100%;
  letter-spacing: 0px;
  opacity: 1;

  span {
    flex: 1;
    height: 24px;
    line-height: 24px;
  }

  time {
    cursor: pointer;
  }
}
.table-header-unfixed {
  border-top: 1px solid #dfe2e8;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  margin-bottom: 0;
}
.table-header-list-item {
  display: flex;
  cursor: move;
  height: 40px;
  padding: 4px 8px;

  .el-checkbox__label {
    height: 32px;
    line-height: 32px;
  }

  .table-header-labelContainer {
    flex: 1;
    height: 32px;
    line-height: 32px;
    margin-left: 10px;
  }
}
.table-header-noFixedItem {
  font-family: PingFang SC;
  font-size: 14px;
  color: #929aa6;
  letter-spacing: 0px;
  line-height: 0px;
  opacity: 1;
  height: 40px;
  line-height: 32px;
  padding: 4px 8px;
  list-style: none;
}
.table-header-text-right {
  text-align: right;
  border-top: 1px solid #dddddd;
  padding-top: 10px;
  margin-top: 6px;
}
.table-header-list-item {
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background: rgb(35, 127, 250) !important;
    border-color: rgb(35, 127, 250) !important;
    opacity: 0.4 !important;
    color: #ffffff !important;
  }
}
</style>
